import {PlayInfoResponse} from '../interface/byteplusVideo.interface';
import {TraceApiEndpointBuilder} from '../traceApi';

export const createByteplusEndpoint = (builder: TraceApiEndpointBuilder) => ({
  getByteplusVideo: builder.query<PlayInfoResponse, string>({
    query: id => ({
      url: `/byteplus/play-info/${id}`,
      method: 'GET',
    }),
  }),
});
